import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

export default function DatePickerPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const type = location.state?.type; // created / due
  const [date, setDate] = useState(new Date());

  const handleSelect = (d) => {
    setDate(d);
    const formatted = d.toLocaleDateString("en-GB");

    if (type === "created") {
      localStorage.setItem("createdDate", formatted);
    } else {
      localStorage.setItem("dueDate", formatted);
    }

    navigate(-1);
  };

  return (
    <div className="date-page d-flex justify-content-center align-items-center">
      <DatePicker inline selected={date} onChange={handleSelect} />

      {/* STYLE */}
      <style>{`
        .date-page {
          height: 100vh;
          background: #f5f5f5;
        }

        .react-datepicker {
          border-radius: 12px;
          padding: 10px;
          border: none;
          box-shadow: 0 5px 20px rgba(0,0,0,0.1);
        }

        .react-datepicker__header {
          background: #fff;
          border-bottom: none;
          font-weight: 600;
        }

        .react-datepicker__day--selected {
          background: #ff6a00 !important;
          color: #fff;
          border-radius: 6px;
        }

        .react-datepicker__day:hover {
          background: #ffe5d0;
        }
      `}</style>
    </div>
  );
}
